<h5 mat-dialog-title style="padding-left: 30px;">{{ modalData.title }}</h5>

<mat-dialog-content id="lifedi-modal" class="mat-typography">
  <div [innerHTML]="modalData.description" class="text-center"></div>
  <!-- <span> {{ modalData.description }}</span> -->
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button *ngIf="!modalData.isDelete" mat-button mat-dialog-close class="lifedi-btn-success" (click)="actionFunction()"
    style="box-shadow: 0 1px 1px -2px #0003, 0 1px 1px #00000024, 0 1px 5px #0000001f;">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="modalData.isDelete" mat-button mat-dialog-close class="lifedi-btn-danger" (click)="actionFunction()"
    style="box-shadow: 0 1px 1px -2px #0003, 0 1px 1px #00000024, 0 1px 5px #0000001f;">
    {{ modalData.actionBtnText }}
  </button>

  <button mat-button [mat-dialog-close]="true" (click)="closeModal()"
    style="box-shadow: 0 1px 1px -2px #0003, 0 1px 1px #00000024, 0 1px 5px #0000001f;">
    {{ modalData.cancleBtnText }}
  </button>
</mat-dialog-actions>
